'use client'

import { MODAL_TYPE, Modal, type ModalAPI } from 'fukku/Modal'
import dynamic from 'next/dynamic'
import { useEffect, useRef } from 'react'

import {
	type CustomizationContextType,
	useCustomization,
} from '../../../contexts/CustomizationProvider/CustomizationProvider'
import { useSizes } from '../../../contexts/SizesProvider/SizesProvider'
import type { FullProduct, Size } from '../../../types/FullProduct'

const DynamicCustomization = dynamic(() =>
	import(
		'product-customization/components/ProductCustomization/ProductCustomization'
	).then((component) => component.ProductCustomization)
)

export function CustomizationModal({
	colorId,
	lookId,
	product,
}: {
	colorId: string
	lookId: string
	product: FullProduct
}) {
	const { selectedSize } = useSizes()
	selectedSize as Size
	const modalRef = useRef<ModalAPI>(null)
	const { isCustomizationOpen, setIsCustomizationOpen } =
		useCustomization() as CustomizationContextType
	const onCustomizationClose = (): void => {
		setIsCustomizationOpen(false)
	}

	useEffect(() => {
		if (isCustomizationOpen) {
			modalRef.current?.show()
		}
	}, [isCustomizationOpen])

	if (!selectedSize) {
		return null
	}

	const productCustomization = {
		lastUnits: !!selectedSize.lastUnits,
		productId: product.id,
		seller: product.seller,
		sizeId: selectedSize.id,
		colorId,
		lookId,
	}

	return (
		<Modal
			name='customization-modal'
			onClose={onCustomizationClose}
			ref={modalRef}
			title='Bordados'
			type={MODAL_TYPE.FULL_SCREEN}
		>
			<DynamicCustomization product={productCustomization} />
		</Modal>
	)
}
